export default __webpack_public_path__ + "static/media/sites-mob9.046c25f9.png";